export default __webpack_public_path__ + "static/media/faq.e578cf14.svg";